import PropTypes from 'prop-types';

function status(status, capitalize = false) {
  if (capitalize) {
    return status.replace('-', ' ').replace(status[0], status[0].toUpperCase());
  }
  return status.replace('-', ' ');
}

status.PropTypes = {
  status: PropTypes.string.isRequired,
};

export { status };
